const Bill: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <path
        fill="currentColor"
        d="M15.8333 1.66675C15.8333 2.12675 15.46 2.50008 15 2.50008C14.54 2.50008 14.1667 2.12675 14.1667 1.66675H12.5C12.5 2.12675 12.1267 2.50008 11.6667 2.50008C11.2067 2.50008 10.8333 2.12675 10.8333 1.66675H9.16667C9.16667 2.12675 8.79333 2.50008 8.33333 2.50008C7.87333 2.50008 7.5 2.12675 7.5 1.66675H5.83333C5.83333 2.12675 5.46 2.50008 5 2.50008C4.54 2.50008 4.16667 2.12675 4.16667 1.66675H2.5V16.6667C2.5 17.5876 3.24583 18.3334 4.16667 18.3334H15.8333C16.7542 18.3334 17.5 17.5876 17.5 16.6667V1.66675H15.8333ZM10.8333 15.0001H5.83333V13.3334H10.8333V15.0001ZM10.8333 11.6667H5.83333V10.0001H10.8333V11.6667ZM14.1667 15.0001H12.5V13.3334H14.1667V15.0001ZM14.1667 11.6667H12.5V10.0001H14.1667V11.6667ZM14.1667 7.50008H5.83333V5.83341H14.1667V7.50008ZM15.8333 16.6667H4.16667V4.16675H15.8333V16.6667Z"
      />
    </svg>
  );
};

export default Bill;
